
import { Vue, prop, Options } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";

class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  iconLeft = prop<string>({
    default: "",
    type: String
  });
  message = prop<string>({
    type: String,
    default: ""
  });
  isPositive = prop<boolean>({
    type: Boolean,
    default: true
  });
  timeout = prop<number>({
    type: Number,
    default: 0
  });
  autoClose = prop<boolean>({
    type: Boolean,
    default: false
  });
  snackbarBackgroundColor = prop<string>({
    type: String,
    default: ""
  });
  textColor = prop<string>({
    type: String,
    default: "text-white"
  });
  customWidth = prop<string>({
    type: String,
    default: "390px"
  });
}

let timeout: any = null;

@Options({
  emits: ["update:modelValue", "onClose"],
  watch: {
    $route() {
      this.closeSnackbar();
    },
    modelValue() {
      if (this.modelValue) {
        if (this.timeout > 0 || this.autoClose) {
          timeout = setTimeout(
            () => {
              this.closeSnackbar();
            },
            this.autoClose ? 2000 : this.timeout
          );
        }
        return;
      }
    }
  }
})
export default class Snackbar extends Vue.with(Props) {
  closeSnackbar() {
    MainAppController.setSnackbarTimeout(0);
    MainAppController.setSnackbarPositivity(true);
    MainAppController.setSnackbarBackgroundColor("");
    this.$emit("onClose");
    this.$emit("update:modelValue", false);
  }

  unmounted() {
    clearTimeout(timeout);
    this.closeSnackbar();
  }

  get backgroundColorStyle() {
    if (this.snackbarBackgroundColor) {
      return {
        backgroundColor: this.snackbarBackgroundColor,
        width: this.customWidth
      };
    }
    return this.isPositive
      ? { backgroundColor: "#00875A", width: this.customWidth }
      : { backgroundColor: "#B82025", width: this.customWidth };
  }

  get iconLeftAsset() {
    if (this.iconLeft) {
      return this.iconLeft;
    }
    return this.isPositive ? "snackbar-success" : "icon-x-white";
  }
}
